var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "currentColor",
    viewBox: "0 0 17 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 7.75q-.0547.6015-.6563.6563h-4.375v4.3749q-.0547.6016-.6562.6563-.6015-.0547-.6562-.6563v-4.375h-4.375q-.6015-.0547-.6563-.6562.0547-.6015.6563-.6562h4.375v-4.375q.0547-.6015.6562-.6563.6015.0547.6563.6563v4.375h4.3749q.6016.0547.6563.6562"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus-icon.b17e70f9d8feb8781ef13839d09500a1.svg";